<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.css";
import toStrapiLocale from "~/helpers/toStrapiLocale";
const { locale } = useI18n();
const { $get } = useAxios();

const { data: coins } = await useAsyncData(`get popular coins`, () =>
  $get(
    `/coins?_limit=6&_sort=published_at:desc&_locale=${toStrapiLocale(
      locale.value
    )}`
  )
);

const mySwiper = ref(null);

const onSwiper = (swiperInstance) => {
  mySwiper.value = swiperInstance;
};

const slideNext = () => {
  if (mySwiper.value) {
    mySwiper.value.slideNext();
  } else {
  }
};

const slidePrev = () => {
  if (mySwiper.value) {
    mySwiper.value.slidePrev();
  } else {
  }
};
</script>
<template>
  <div class="container">
    <p
      class="text-xl px-4 xl:px-0 md:text-3xl xl:text-[28px] font-firasans mb-3"
    >
      Популярные монеты
    </p>
    <div class="w-full relative">
      <div class="hidden lg:block">
        <div
          class="w-[58px] h-[58px] bg-darkYellow absolute left-0 rounded-full flex justify-center p-4 z-10 cursor-pointer"
          style="top: 50%; transform: translateY(-50%)"
          @click="slidePrev"
        >
          <a-icon-arrow class="rotate-90" color="#fff"></a-icon-arrow>
        </div>
        <div
          class="w-[58px] h-[58px] bg-darkYellow absolute right-0 rounded-full flex justify-center p-4 z-10 cursor-pointer"
          style="top: 50%; transform: translateY(-50%)"
          @click="slideNext"
        >
          <a-icon-arrow class="-rotate-90" color="#fff"></a-icon-arrow>
        </div>
      </div>
      <swiper
        class="!py-3 !px-4 lg:!px-[120px]"
        :slides-per-view="1.2"
        :loop="false"
        :space-between="30"
        :centered-slides="false"
        :breakpoints="{
          '325': {
            slidesPerView: 2.1,
            spaceBetween: 10,
          },
          '640': {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          '1024': {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          '1180': {
            slidesPerView: 4,
            spaceBetween: 85,
          },
        }"
        @swiper="onSwiper"
      >
        <swiper-slide
          v-for="(coin, index) in coins"
          :key="index"
          class="card border-[#F3F3F7] border rounded-[20px] !w-34 md:!w-43 max-w-43 overflow-hidden px-[8px] md:px-[10px] pt-3 pb-[10px] relative max-h-64"
        >
          <a-coin-slide :coin="coin"> </a-coin-slide>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<style scoped>
.card:hover {
  -webkit-box-shadow: 0px 0px 12px 0px rgba(61, 61, 61, 0.15);
  box-shadow: 0px 0px 12px 0px rgba(61, 61, 61, 0.15);
}

.card .dots span:first-child {
  background: #FCC900 !important;
  width: 6px !important;
  height: 6px !important;
  border: none !important;
}

.card .dots span:last-child {
  width: 6px !important;
  height: 6px !important;
  border: none !important;
  background: #d9d9d9 !important;
}

.card:hover .dots span:last-child {
  background: #FCC900 !important;
}

.card:hover .dots span:first-child {
  background: #d9d9d9 !important;
}

.coinData_image {
  -webkit-transition: all 0.5s ease 0.2s;
  -o-transition: all 0.5s ease 0.2s;
  transition: all 0.5s ease 0.2s;
  position: absolute;
  /* width: 100%;
  height: 100%; */
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: center center;
  object-position: center center;
}

.dots span {
  transition: all 0.5s ease 0.2s;
  margin: 0 3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1px solid #b7b7b7;
}
</style>
